import { toggleFavorite } from "@/lib/favorite-actions";

type Props = {
  listingId: string;
  isFavorite: boolean;
  size?: "sm" | "md";
};

export default function FavoriteButton({ listingId, isFavorite, size = "sm" }: Props) {
  const cls = size === "md"
    ? "w-9 h-9 text-xl"
    : "w-7 h-7 text-base";
  return (
    <form action={toggleFavorite} className="inline-block">
      <input type="hidden" name="listingId" value={listingId} />
      <button
        aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
        className={`${cls} rounded-full bg-white/90 hover:bg-white border border-neutral-200 flex items-center justify-center shadow transition`}
      >
        <span className={isFavorite ? "text-rose-600" : "text-neutral-400"}>
          {isFavorite ? "♥" : "♡"}
        </span>
      </button>
    </form>
  );
}
